import React, { useEffect, useRef, useState } from 'react'
import Slider from "react-slick";
import Marquee from "react-fast-marquee";
import { getImages } from '../Common/const';
const carData = [
    {
        image: 'srp-img1.webp',
        title: '2022 McLaren 765LT',
        price: '$523,777',
        mileage: '575mi',
    },
    {
        image: 'srp-img2.webp',
        title: '1972 Ferrari Dino 246 GTB',
        price: '$519,777',
        mileage: '3,767mi',
    },
    {
        image: 'srp-img3.webp',
        title: '2015 Ferrari 458 Italia',
        price: '$479,888',
        mileage: '11,682mi',
    },
]
const carData1 = [
    {
        image: 'srp-img4.webp',
        title: '2023 Rolls-Royce Phantom',
        price: '$478,777',
        mileage: '7,194mi',
    },
    {
        image: 'srp-img5.webp',
        title: '1969 Chevrolet Camaro SS',
        price: '$382,777',
        mileage: '8,030mi',
    },
    {
        image: 'srp-img6.webp',
        title: '2021 Chevrolet Corvette',
        price: '$359,888',
        mileage: '3,026mi',
    },
]
const FeaturedVehicles = ({ featuredVehicles, numberFormatter }) => {

    var featuredSettings1 = {
        speed: 500, // Reduce speed for a better pause effect
        autoplay: true,
        autoplaySpeed: 3000, // Set a reasonable autoplay speed
        centerMode: false,
        cssEase: 'ease-in-out',
        draggable: false,
        focusOnSelect: false,
        pauseOnFocus: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        pauseOnDotsHover: true,
        rtl: true
    };
    var featuredSettings2 = {
        speed: 12000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        draggable: false,
        focusOnSelect: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
        pauseOnFocus: true,
        pauseOnHover: true,
    };
    const [isFvMobile, setIsFvMobile] = useState(false);
    const handleFvResize = () => {
        setIsFvMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleFvResize();
        window.addEventListener('resize', handleFvResize);
        return () => {
            window.removeEventListener('resize', handleFvResize);
        };
    }, []);
    return (
        <>
            <section className='featured-vehicles-wrap'>
                <div className='container'>
                    <div className='main-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Featured Vehicles</div>
                    <div className='featured-vehicles-block wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                        {/* <Slider  ref={sliderRef} 
                        {...featuredSettings1} 
                        onMouseEnter={() => sliderRef.current?.slickPause()} 
                        onMouseLeave={() => sliderRef.current?.slickPlay()}> */}
                        <Marquee className='featured-vehicles-block' speed={isFvMobile ? 30:38 } pauseOnHover={true}>
                            {featuredVehicles.map((car, index) => {
                                if (index >= featuredVehicles.length / 2) return false;
                                return (
                                    <div key={index}>
                                        <div className='inner'>
                                            <article className="cs-card cs-card--2 fv-box">
                                                <div className="cs-card__img fv-top"
                                                    style={{
                                                        backgroundImage: `url(${car.images[0]})`,
                                                    }}
                                                ></div>
                                                <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} className="cs-card_link">
                                                    <div className="cs-card__img--hover fv-top"
                                                        style={{
                                                            backgroundImage: `url(${car.images[0]})`,
                                                        }}></div>
                                                </a>
                                                <div className="fv-bottom">
                                                    <div className="sm-title text-theme font-bold">{car.vehicle_name}</div>
                                                    <div className="d-flex align-items-center justify-content-between mt-1">
                                                        <div className="sm-title">{numberFormatter(car.price, true)}</div>
                                                        <div className="sm-title opacity-0-7">{numberFormatter(car.mileage)}</div>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    </div>)
                            })}
                        </Marquee>
                        {/* </Slider> */}
                        {/* <Slider {...featuredSettings2}> */}
                        <Marquee className='featured-vehicles-block' speed={isFvMobile ? 30:38 } pauseOnHover={true} direction="right">
                            {featuredVehicles.map((car, index) => {
                                if (index < featuredVehicles.length / 2) return false;
                                return (
                                    <div key={index}>
                                        <div className='inner'>
                                            <article className="cs-card cs-card--2 fv-box">
                                                <div className="cs-card__img fv-top"
                                                    style={{
                                                        backgroundImage: `url(${car.images[0]})`,
                                                    }}
                                                ></div>
                                                <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} className="cs-card_link">
                                                    <div className="cs-card__img--hover fv-top"
                                                        style={{
                                                            backgroundImage: `url(${car.images[0]})`,
                                                        }}></div>
                                                </a>
                                                <div className="fv-bottom">
                                                    <div className="sm-title text-theme font-bold">{car.vehicle_name}</div>
                                                    <div className="d-flex align-items-center justify-content-between mt-1">
                                                        <div className="sm-title">{numberFormatter(car.price, true)}</div>
                                                        <div className="sm-title opacity-0-7">{numberFormatter(car.mileage)}</div>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    </div>)
                            })}
                        </Marquee>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FeaturedVehicles